import { render, staticRenderFns } from "./_detailDialog.vue?vue&type=template&id=165a0bfe&"
import script from "./_detailDialog.vue?vue&type=script&lang=js&"
export * from "./_detailDialog.vue?vue&type=script&lang=js&"
import style0 from "./_detailDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports